import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { decorators, DataRow, getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';

// ducks
import { paginateThis } from '../../ducks/AssistedLivingSearch';

// components
import LoadError from '../../components/load-error/load-error';

// containers
import AssistedLivingSearchResult from './AssistedLivingSearchResult';

// modules
import BS from '../../theme/Bootstrap';

class AssistedLivingSearchResults extends PureComponent {
  render() {
    const { ids, className, isLoading, loadError, reload } = this.props;

    return (
      <Container className={cx(className, BS.flex1, BS.positionRelative)}>
        <Row className={BS.justifyContentStart}>
          {ids.map((id, i) => {
            return (
              <Col xs={12} className={`${BS.mb3}`} key={i}>
                <DataRow itemId={id} component={AssistedLivingSearchResult} index={i} />
              </Col>
            );
          })}
          {loadError && !isLoading && (
            <Col xs={12}>
              <LoadError error={loadError} retry={reload} />
            </Col>
          )}
          {ids.length === 0 && !isLoading && !loadError && (
            <Col xs={12} className={`${BS.mb3} ${BS.textCenter}`}>
              No Results
            </Col>
          )}
        </Row>
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </Container>
    );
  }
}

export default decorators.tabulateLean(
  connect(
    (state, props) => {
      const paginator = getPaginator(props.listId, state),
        loadError = paginator.get('loadError');

      return {
        loadError
      };
    },
    {
      reload: paginateThis.pageActions.reload
    }
  )(AssistedLivingSearchResults)
);



// WEBPACK FOOTER //
// ./src/containers/AssistedLivingSearch/AssistedLivingSearchResults.js